import { render } from "./Wserver.vue?vue&type=template&id=17a4154e&scoped=true"
import script from "./Wserver.vue?vue&type=script&lang=js"
export * from "./Wserver.vue?vue&type=script&lang=js"

import "./Wserver.vue?vue&type=style&index=0&id=17a4154e&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a4154e"]])

export default __exports__